import useAuthStore, {subscribeAuth} from "app/Service/Auth/AuthService"
import Logger from "logger/logger"
import {useEffect} from "react"
import {useNavigate} from "react-router-dom"

function AuthNavigationService() {

  const navigate = useNavigate()
  const authLocations = [
    '/forgot-password',
    '/reset-password',
    '/register',
  ]

  const {isAuthenticated, token} = useAuthStore([
    subscribeAuth.isAuthenticated,
    subscribeAuth.token
  ], 'AuthNavigationService')

  useEffect(() => {
    Logger('Service.Auth.Navigation.init')
    return () => {
      Logger('Service.Auth.Navigation.unloading')
    }
  }, [])

  // Navigate to new 'homepage' based on authentication status
  useEffect(function navigateOnAuth() {
    if (undefined === isAuthenticated) return
    if (isAuthenticated && authLocations.some(x => location.pathname.includes(x))) {
      Logger('Service.Auth.Navigation.init', 'go to application')
      navigate('/')
    } else if ((!token || !isAuthenticated) && !authLocations.some(x => location.pathname.includes(x))) {
      Logger('Service.Auth.Navigation.init', 'go to site')
      navigate('/')
    }
  }, [isAuthenticated])

  return null
}

export default AuthNavigationService
